export enum CustomMetricTypes {
  STRING = 'string',
  INTEGER = 'int',
  BOOLEAN = 'bool',
  FLOAT = 'float',
}

export enum ImportFileType {
  YAML = 'yaml',
}

export interface PostCustomMetricsRequest {
  name: string;
  type: CustomMetricTypes;
  description?: string | null;
  expected_values?: string[] | null;
  api?: boolean;
}

export interface PatchCustomMetricsRequest {
  description?: string | null;
  expected_values?: string[] | null;
  active?: boolean;
  api?: boolean;
}

export interface CustomMetricsResponse {
  name: string;
  account_id: string;
  project_id: string;
  type: CustomMetricTypes;
  description: string | null;
  expected_values: string[] | null;
  active: boolean;
  api: boolean;
  updated_at: string;
  updated_by: string;
}

export interface CustomMetricsImportItem {
  name: string;
  message: string;
}

export interface ImportCustomMetricsMetadata {
  created: CustomMetricsImportItem[];
  ignored: CustomMetricsImportItem[];
}

export interface CustomMetricsImportResponse {
  errors: CustomMetricsImportItem[];
  metadata: ImportCustomMetricsMetadata;
  import_result: CustomMetricsResponse[];
}

export interface CustomMetricsImportRequest {
  file: File;
  dryRun: boolean;
}
